<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->
<div class="tableau__main-container">
  <div #tableauViz class="ptl-tableau-viz"></div>
</div>
